var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70679 14.5453C7.51926 14.7328 7.26495 14.8381 6.99979 14.8381C6.73462 14.8381 6.48031 14.7328 6.29279 14.5453L0.292786 8.5453C0.105315 8.35777 0 8.10346 0 7.8383C0 7.57313 0.105315 7.31883 0.292786 7.1313L6.29279 1.1313C6.48139 0.94914 6.73399 0.848345 6.99619 0.850624C7.25838 0.852902 7.5092 0.958071 7.6946 1.14348C7.88001 1.32889 7.98518 1.5797 7.98746 1.8419C7.98974 2.10409 7.88894 2.3567 7.70679 2.5453L3.41379 6.8383H14.9998C15.265 6.8383 15.5194 6.94366 15.7069 7.13119C15.8944 7.31873 15.9998 7.57308 15.9998 7.8383C15.9998 8.10351 15.8944 8.35787 15.7069 8.5454C15.5194 8.73294 15.265 8.8383 14.9998 8.8383H3.41379L7.70679 13.1313C7.89426 13.3188 7.99957 13.5731 7.99957 13.8383C7.99957 14.1035 7.89426 14.3578 7.70679 14.5453Z",
    fill: "#0F172A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.bb4d04cb47e2210d464a597d37b79a41.svg";
export { ForwardRef as ReactComponent };